import { collationOfficerType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, updateAPI } from '../api-utils';

export const create = createAPI<undefined, { userId: number; wardId: number }>({
	actionType: collationOfficerType.create,
	url: '/api/v1/CollationOfficer',
});

export const get = getAPI({
	actionType: collationOfficerType.get,
	url: '/api/v1/CollationOfficer',
	type: 'core',
});

export const getByID = getByIdAPI({
	actionType: collationOfficerType.getByID,
	url: '/api/v1/CollationOfficer',
});

export const update = updateAPI<
	undefined,
	{
		id: number;
		userId: number;
		wardId: number;
	}
>({
	actionType: collationOfficerType.update,
	url: '/api/v1/CollationOfficer/update',
});

export const deleteById = deleteByIdAPI({
	actionType: collationOfficerType.deleteById,
	url: '/api/v1/CollationOfficer/delete',
});
